import React, { useContext } from 'react';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import { CustomDialogBodySizeEditable } from '../../../../../common/ModalSizeEditableContext';
import { ButtonConfirm } from '../../../../../common/buttons/ButtonConfirm';
import ProvisionamentoContext from './ProvisionamentoContext';

const ModalConfirmaRecalculo = () => {
	const {
		executaRecalculo,
		closeModal,
		handleProvisionar,
		loadingArrecadacoes,
		realizandoRecalculo,
		realizandoProvisionamento,
	} = useContext(ProvisionamentoContext);

	return (
		<CustomDialogBodySizeEditable
			text='Deseja recalcular as arrecadações antes de realizar o provisionamento?'
			title='Recálculo de arrecadações'
			customActions={
				<>
					<Button
						variant='text'
						onClick={closeModal}
						size='small'
						startIcon={<CloseIcon />}
						disabled={realizandoRecalculo || realizandoProvisionamento}
					>
						Cancelar
					</Button>
					<ButtonConfirm
						loading={realizandoRecalculo}
						disabled={loadingArrecadacoes || realizandoProvisionamento}
						onClick={executaRecalculo}
					>
						Recalcular
					</ButtonConfirm>
					<ButtonConfirm
						loading={realizandoProvisionamento}
						disabled={loadingArrecadacoes || realizandoRecalculo}
						onClick={handleProvisionar}
					>
						Provisionar
					</ButtonConfirm>
				</>
			}
		/>
	);
};

export default ModalConfirmaRecalculo;
